<script setup lang="ts">
	interface IProps {
		messages: { message: string; type: 'success' | 'error' }[];
	}
	defineProps<IProps>();
</script>

<template>
	<div class="toast-container">
		<TransitionGroup name="fade">
			<div
				v-for="(msg, index) in messages"
				:key="index"
				:class="['toast', msg.type]"
				role="alert"
				aria-live="assertive"
			>
				{{ msg.message }}
			</div>
		</TransitionGroup>
	</div>
</template>

<style scoped>
	.toast-container {
		position: fixed;
		bottom: 20px;
		right: 20px;
		display: flex;
		flex-direction: column;
		gap: 10px;
	}
	.toast {
		padding: 15px 20px;
		border-radius: 5px;
		color: white;
		font-weight: bold;
		box-shadow: var(--box-shadow);
		z-index: 1001;
		overflow: hidden;
	}

	.success {
		background: var(--color-success);
	}

	.error {
		background: var(--color-error);
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s cubic-bezier(0.34, 1.56, 0.64, 1),
			transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
	}

	.fade-enter-from,
	.fade-leave-to {
		opacity: 0;
		transform: translateX(300%);
	}
</style>
